// assets/contact-form.js

document.addEventListener('DOMContentLoaded', function() {
  const form = document.getElementById('custom-contact-form');
  if (form) {
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      
      const responseMessage = document.getElementById('response-message');
      responseMessage.style.display = 'none';
      responseMessage.textContent = '';

      const apiKey = form.dataset.apiKey;
      const apiEndpoint = form.dataset.apiEndpoint;

      if (!apiKey || !apiEndpoint) {
        showMessage("Form is not properly configured. Please contact the site administrator.", "red");
        console.error("API Key or Endpoint missing");
        return;
      }

      const formData = new FormData(e.target);
      const products = Array.from(formData.getAll('product')).join(', ');
      const phoneType = formData.get('phone-type');
      
      let description = formData.get('message') + "\n\n";
      description += "Additional Information:\n";
      if (products) description += "Products: " + products + "\n";
      if (phoneType) description += "Phone Type: " + phoneType + "\n";
      if (formData.get('order-id')) description += "Order ID: " + formData.get('order-id') + "\n";
      if (formData.get('country')) description += "Country: " + formData.get('country') + "\n";

      const data = new URLSearchParams({
        username: "PlegiumComContact",
        key: apiKey,
        endpoint: "ticket-add",
        type: "135",
        firstname: formData.get('your-name').split(' ')[0],
        lastname: formData.get('your-name').split(' ').slice(1).join(' '),
        email: formData.get('email'),
        mobile: "",
        phone: "",
        heading: formData.get('title'),
        description: description,
      });

      console.log("Sending data:", data.toString());
      console.log("To endpoint:", apiEndpoint);

      fetch(apiEndpoint, {
        method: 'POST',
        body: data,
        mode: 'no-cors',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        }
      })
      .then(() => {
        showMessage("Thank you for your message. It has been successfully submitted. For reference, please save the date and time of your submission. If you need to follow up, mention this information in your communication.", "green");
        e.target.reset();
      })
      .catch((error) => {
        console.error('Fetch error:', error);
        showMessage("An error occurred while submitting your message. Please try again later or contact support directly.", "red");
      });
    });
  }

  function showMessage(message, color) {
    const responseMessage = document.getElementById('response-message');
    responseMessage.textContent = message;
    responseMessage.style.color = color;
    responseMessage.style.display = 'block';
    responseMessage.scrollIntoView({ behavior: 'smooth' });
  }
});